export default __webpack_public_path__ + "static/天下第一配音徵選_BN-7d1309ab11ac3872b5f568ea9c5aaf77.webp";